<template>
  <div class="question-success-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">

      <div class="registry-success">
        <div class="icon mx-auto"></div>

        <div class="text">问卷提交成功</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isMobile } from '@/utils/index'

export default {
  data() {
    return {

    }
  },
  methods: {
    isMobile,


  },
  created() {
  }
}
</script>

<style lang="scss">
.question-success-container {
  background: $bg;

  .registry-success {
    padding: 60px 0;
    text-align: center;
    .icon {
      width: 56px;
      height: 56px;
      margin-bottom: 30px;
      background: url(~@/assets/success-icon.png) no-repeat;
      background-size: 100% 100%;
    }

    .text {
      font-size: 20px;
      font-weight: 400;
      color: #596270;
      line-height: 24px;
      margin-bottom: 15px;
    }

    .login {
      font-size: 14px;
      font-weight: 400;
      color: $primary;
      line-height: 24px;
      cursor: pointer;
    }
  }



  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;
    }
  }

  .sys-max-width {
    padding: 49px 0px 71px;

  }
}
</style>
